import styled from 'styled-components'

export const Section = styled.section`
  width: min(1540px, calc(100% - 48px));
  margin: 0 auto 34px;
  padding: 18px;
  border: 1px solid #ececec;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 8px 26px rgba(0, 0, 0, 0.05);

  @media (max-width: 640px) {
    width: calc(100% - 24px);
    margin-bottom: 24px;
    padding: 12px;
    border-radius: 15px;
  }
`

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 12px;

  @media (max-width: 700px) {
    gap: 10px;
    flex-direction: column;
  }
`

export const Title = styled.h2`
  margin: 0;
  color: #1d232b;
  font-size: 24px;
  line-height: 1.15;

  @media (max-width: 640px) {
    font-size: 20px;
  }
`

export const Subtitle = styled.p`
  margin: 5px 0 0;
  color: #777f89;
  font-size: 12px;
`

export const Legend = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: #606873;
  font-size: 11px;
  font-weight: 700;

  > span {
    display: flex;
    align-items: center;
    gap: 5px;
  }
`

export const LegendPin = styled.span`
  width: 18px;
  height: 21px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  img {
    width: 16px;
    height: 18px;
    object-fit: contain;
  }

  &.planned img {
    filter: none;
  }

  &.visited img {
    filter: none;
  }
`

export const MapShell = styled.div`
  height: 360px;
  overflow: hidden;
  border-radius: 14px;
  background: #eef2f5;

  .mapboxgl-popup-content {
    padding: 0;
    border-radius: 12px;
    overflow: hidden;
  }

  @media (max-width: 700px) {
    height: 270px;
    border-radius: 12px;
  }
`

export const PinButton = styled.button`
  width: 30px;
  height: 34px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;

  img {
    width: 28px;
    height: 31px;
    object-fit: contain;
    filter: drop-shadow(0 3px 7px rgba(0, 0, 0, 0.22));
  }

  &.planned img {
    filter: drop-shadow(0 3px 7px rgba(0, 0, 0, 0.22));
  }

  &.visited img {
    filter: drop-shadow(0 3px 7px rgba(0, 0, 0, 0.22));
  }

  @media (max-width: 640px) {
    width: 27px;
    height: 31px;

    img {
      width: 25px;
      height: 28px;
    }
  }
`

export const PopupContent = styled.div`
  min-width: 180px;
  padding: 12px 13px;

  strong {
    display: block;
    color: #262c34;
    font-size: 13px;
  }

  span,
  small {
    display: block;
    margin-top: 3px;
    color: #7a828d;
    font-size: 10px;
  }

  button {
    margin-top: 9px;
    padding: 7px 10px;
    border: 0;
    border-radius: 8px;
    background: #e50909;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    cursor: pointer;
  }
`

export const Summary = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border: 1px solid #eceff2;
  border-radius: 12px;
  overflow: hidden;

  > div {
    min-height: 58px;
    padding: 10px 14px;
    display: flex;
    align-items: center;
    gap: 7px;
    border-left: 1px solid #eceff2;
  }

  > div:first-child {
    border-left: 0;
  }

  strong {
    color: #262d35;
    font-size: 16px;
  }

  span {
    color: #808791;
    font-size: 10px;
  }

  @media (max-width: 640px) {
    > div {
      min-height: 50px;
      padding: 8px;
      gap: 5px;
    }

    strong {
      font-size: 14px;
    }

    span {
      font-size: 8px;
    }
  }
`

export const SummaryPin = styled.span`
  width: 17px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  img {
    width: 16px;
    height: 18px;
    object-fit: contain;
  }

  &.planned img {
    filter: none;
  }

  &.visited img {
    filter: none;
  }
`
